import { COACHING_TYPE_LABEL, capitalised, careWords, firstName, formatDate, formatDay, formatTime, plural, programmeName, splitSessions, } from "@healthos/shared";
/** Everything the member's coaching page shows, worked out once for both clients. */
export function coachingMemberView(me, now, page = "coaching") {
    const programme = me?.programme ?? null;
    const coach = me?.coach ?? null;
    const kind = programme?.kind ?? page;
    const words = careWords(kind);
    const care = kind === "care_team";
    const coachFirst = coach ? firstName(coach.name) : capitalised(words.yourTeam);
    const { upcoming, past } = splitSessions(me?.sessions ?? [], now);
    const unread = me?.unreadMessages ?? 0;
    return {
        programme,
        coach,
        kind,
        words,
        care,
        coachFirst,
        upcoming,
        past,
        waiting: me?.assessments.filter((a) => a.completedAt === null) ?? [],
        canBook: programme !== null && programme.sessionsRemaining > 0 && coach !== null,
        unread,
        title: coach ? `${care ? "Care from" : "Coaching with"} ${coach.name}` : words.area,
        titleLead: care ? "Care from" : "Coaching with",
        subtitle: care
            ? "Appointments and messages with your care team."
            : "One to one video sessions with your coach.",
        unreadLabel: coach && unread > 0
            ? unread === 1
                ? `New message from ${coachFirst}`
                : `${unread} new messages from ${coachFirst}`
            : null,
        programmeLeft: programme
            ? `${programme.sessionsRemaining} of ${programme.sessionCap} ${words.sessions} left`
            : null,
        runsUntil: programme ? `Runs until ${formatDate(programme.endsOn)}` : null,
        notOnPlan: {
            title: `${words.area} is not part of your plan yet`,
            body: kind === "care_team"
                ? "If your care is offered through HealthOS, your care team will appear here."
                : "If your employer offers coaching, you will be invited and your coach will appear here.",
        },
        unmatched: {
            title: `You will be matched with a ${words.professional} soon`,
            body: `Once you are matched, you can book your first ${words.session} here.`,
        },
        notice: {
            moved: "Moved. Your calendar invite has been updated.",
            cancelled: `Cancelled. The ${words.session} is back on your programme.`,
            booked: "Booked. A calendar invite is on its way to you.",
            sent: `Sent. ${coachFirst} can see your answers now.`,
        },
    };
}
/** The professional as the member sees them: "Executive coach", or a clinician's own title. */
export function coachCardProps(coach, coachingType, care) {
    const first = firstName(coach.name);
    return {
        first,
        eyebrow: care ? coach.title : `${COACHING_TYPE_LABEL[coachingType] ?? "Your"} coach`,
        threadEmpty: care
            ? `Write to ${first} with a question about your care. Only your care team can read it.`
            : `Write to ${first} between sessions. Only ${first} can read it.`,
    };
}
/** The way into one programme from Today: who it is with, what is next, and how much is waiting. */
export function coachingEntryProps(p) {
    const words = careWords(p.kind);
    const title = p.professional
        ? `${p.kind === "care_team" ? "Care from" : "Coaching with"} ${firstName(p.professional)}`
        : words.area;
    const detail = p.nextSessionAt
        ? `Next ${words.session} ${formatDay(p.nextSessionAt)}, ${formatTime(p.nextSessionAt)}`
        : p.professional && p.sessionsRemaining > 0
            ? `Book your next ${words.session}`
            : programmeName(p.coachingType);
    const count = p.unreadMessages + p.waiting;
    const countLabel = plural(count, "thing waiting for you", "things waiting for you");
    return {
        title,
        detail,
        count,
        path: words.path,
        label: count > 0 ? `${title}. ${detail}. ${countLabel}` : `${title}. ${detail}`,
    };
}
//# sourceMappingURL=coaching-member.js.map